<template>
  <a-select style="width:100%" :placeholder="placeholder" @change="changeHandler" :value="value">
    <a-select-opt-group v-for="group in groups" :label="group.label">
      <a-select-option v-for="option in group.options" :value="option.key">{{option.label}}</a-select-option>
    </a-select-opt-group>
  </a-select>
</template>

<script>
import { POINT_GROUPS, POINT_TYPES } from '@/constants/cvts'

const getOptions = () => {
  return POINT_GROUPS.map(group => {
    return {
      key: group.key,
      label: group.label,
      options: POINT_TYPES.filter(t => t.group === group.key)
    }
  })
}

export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '请选择'
    }
  },

  data () {
    return {
      groups: getOptions() // [{ key: '', label, options: [{ key, label }] }]
    }
  },

  methods: {
    changeHandler (e) {
      this.$emit('input', e)
      this.$emit('change', e)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/PointTypeSelector.vue